export default function Chevron(params) {
  if (!params.withGroup) return null;
  const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"><path d="M5.586 5L2.374 8.67a.5.5 0 10.752.66l3.496-3.995a.499.499 0 000-.67L3.126.671a.5.5 0 10-.752.658L5.586 5z" fill="#B5BDC5" fill-rule="evenodd"/></svg>
    `;
  const chevron = document.createElement('div');
  chevron.classList.add('w5-group-chevron');
  if (!params.data.isGroup) {
    chevron.classList.add('w5-group-chevron--no-group');
    return chevron;
  }
  chevron.innerHTML = svg;
  chevron.addEventListener('click', event => {
    event.preventDefault();
    event.stopPropagation();
    const {
      data,
      api,
      onRequest,
      children,
      node
    } = params;
    if (!data.children) {
      data.isGroupOpen = true;
      data.isLoading = true;
      api.applyTransaction({
        update: [data]
      });
      onExpand(data, api, node.rowIndex, onRequest, children, params.context);
    } else {
      onContract(data, api, params.context);
    }
  });
  return chevron;
}
function getCurrentParentIndex(id, api) {
  let currentParentIndex;
  api.forEachNode(node => {
    if (node.data.id === id) currentParentIndex = node.rowIndex;
  });
  return currentParentIndex;
}
function onGetChildren(id, onRequest, children, api, initialParentIndex, context) {
  return new Promise((resolve, reject) => {
    if (onRequest) {
      const loadingRow = {
        id: `loadingRow${id}`,
        isFullWidth: true,
        isLoader: true
      };
      const data = context.tableData;
      const newData = [...data.slice(0, initialParentIndex + 1), loadingRow, ...data.slice(initialParentIndex + 1, data.length)];
      context.updateTableData(newData);
      api.setRowData(newData);
      onRequest(id).then(response => {
        context.updateTableData(data);
        api.applyTransaction({
          remove: [loadingRow]
        });
        resolve(response);
      }).catch(() => {
        context.updateTableData(data);
        api.applyTransaction({
          remove: [loadingRow]
        });
        reject();
      });
    } else if (children) resolve(children);else reject();
  });
}
function onExpand(data, api, initialParentIndex, onRequest, children, context) {
  onGetChildren(data.id, onRequest, children, api, initialParentIndex, context).then(response => {
    delete data.isLoading;
    if (!response || !Array.isArray(response) || response.length === 0) {
      delete data.isGroupOpen;
      api.applyTransaction({
        update: [data]
      });
      return;
    }
    data.children = response;
    api.applyTransaction({
      update: [data]
    });
    const parentIndex = getCurrentParentIndex(data.id, api);
    const tableData = context.tableData;
    const newData = [...tableData.slice(0, parentIndex + 1), ...response, ...tableData.slice(parentIndex + 1, tableData.length)];
    context.updateTableData(newData);
    api.setRowData(newData);
  });
}
function onContract(data, api, context) {
  api.applyTransaction({
    remove: data.children
  });
  delete data.isGroupOpen;
  delete data.children;
  api.applyTransaction({
    update: [data]
  });
  context.updateTableData(context.tableData.filter(row => !(row.isChildren && row.parentId === data.id)));
}